/* @flow weak */
import enumerate from 'lib/enumerate';
import Organization from 'entities/Organization';

export const ActionTypes = enumerate([
  'LOAD_ORGANIZATION',
  'LOAD_USER_ORGANIZATIONS',
  'REMOVE_ORGANIZATION',
  'REMOVE_ADMIN_ROLE',
  'UPDATE_CURRENT_USER_ORGANIZATION_AFFILIATION',
  'UPDATE_ORG_AFF_VIEW',
]);

export const NO_SCHOOL = new Organization({ id: null, name: 'I don’t work at a school' });
export const UNAFFILIATED = new Organization({ id: null, name: 'Not affiliated with a school' });
